const fetchFrontendVersion = async (): Promise<string | null> => {
  try {
    const response = await fetch("/", { cache: "no-store", method: "HEAD" });

    return response.headers.get("x-rev");
  } catch {
    return null;
  }
};

let appVersionBaseline: Promise<string | null> | null = null;

export const captureAppVersionBaseline = (): Promise<string | null> => {
  if (appVersionBaseline === null) {
    appVersionBaseline = fetchFrontendVersion();
  }

  return appVersionBaseline;
};

export const isAppUpToDate = async (): Promise<boolean> => {
  const [baseline, current] = await Promise.all([
    captureAppVersionBaseline(),
    fetchFrontendVersion(),
  ]);

  return !baseline || !current || baseline === current;
};
